export default __webpack_public_path__ + "static/media/VEB_Vision.0846f22e.png";